module.exports = __webpack_public_path__ + "img/On Rent.9fad5294.jpeg";